<script setup>
import PulsingSubtitle from '@components/global/PulsingSubtitle.vue'
import FeaturedLarge from '@components/events/FeaturedLarge.vue'
import FeaturedMedium from '@components/events/FeaturedMedium.vue'
import FeaturedGrid from '@components/events/FeaturedGrid.vue'

defineProps(['data'])

const blocks = {
	featured_large: FeaturedLarge,
	featured_medium: FeaturedMedium,
	featured_grid: FeaturedGrid,
}
</script>

<template>
	<section class="py-10 md:py-20">
		<div class="container">
			<div class="flex flex-col gap-8 md:gap-10">
				<div class="flex flex-col items-start gap-6 md:w-2/3 md:gap-8">
					<PulsingSubtitle v-if="data.eyebrow">{{ data.eyebrow }}</PulsingSubtitle>
					<h2 v-if="data.title">{{ data.title }}</h2>
				</div>

				<template v-for="(block, index) in data.events_block" :key="index">
					<component :is="blocks[block.type]" v-if="blocks[block.type]" :data="block.data" />
				</template>
			</div>
		</div>
	</section>
</template>
